import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AuthCompact } from "./AuthCompact";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  feature?: string;
  onBrowseAnonymously?: () => void;
}

export const AuthModal = ({ isOpen, onClose, feature, onBrowseAnonymously }: AuthModalProps) => {
  const handleAuthSuccess = () => {
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-sm w-[92vw] p-6 sm:max-w-md" aria-describedby="auth-desc">
        <DialogHeader className="pb-1">
          <DialogTitle className="text-center text-sm">
            {feature ? `Sign in for ${feature}` : "YieldSocial"}
          </DialogTitle>
        </DialogHeader>
        
        <p id="auth-desc" className="sr-only">
          Sign in to your YieldSocial account to access personalized agricultural insights and connect with the farming community.
        </p>
        
        <AuthCompact onAuthSuccess={handleAuthSuccess} />
        {onBrowseAnonymously && (
          <Button
            onClick={() => {
              onBrowseAnonymously();
              onClose();
            }}
            variant="ghost"
            className="w-full text-gray-600 hover:text-gray-800 mt-2"
            size="sm"
          >
            Continue Browsing
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};